import { Button, Constraint, FlexGrid, Image, Loader, Text } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import StationPropType from '../../prop-types/station';
import ReviewItem from '../ReviewItem';
import SubmitReview from '../SubmitReview';
import styles from './Reviews.module.css';

const cx = classnames.bind(styles);

export default function Reviews({
  error,
  hasMoreReviews,
  isFetching,
  loadMore,
  reviews,
  station,
}) {
  const { t } = useTranslation('review');

  let reviewsContent;
  if (isFetching && !reviews?.length) {
    reviewsContent = <Loader />;
  } else if (error) {
    reviewsContent = (
      <Text as="p" color="orange">
        {error}
      </Text>
    );
  } else if (reviews?.length) {
    reviewsContent = (
      <Fragment>
        <FlexGrid container>
          {reviews.map(review => (
            <FlexGrid.Column key={review.reviewId} className={cx('column')} tablet={6}>
              <ReviewItem
                review={review}
                showReplies
                interactive
              />
            </FlexGrid.Column>
          ))}
        </FlexGrid>
        <small className={cx('footnote')}>
          {t('subjectiveOpinion', { ns: 'review' })}
        </small>
        {hasMoreReviews && (
          <Fragment>
            <br />
            <Button
              secondary
              onClick={loadMore}
              loading={isFetching}
              fluid
            >
              {t('loadMore', { ns: 'review' })}
            </Button>
          </Fragment>
        )}
      </Fragment>

    );
  } else {
    reviewsContent = (
      <Fragment>
        <Constraint className={cx('noReviewsContainer')}>
          <Image
            alt={t('addReviewIcon', { ns: 'review' })}
            className={cx('noReviewsImage')}
            src="/assets-v2/svg/icon-add-review.svg"
          />
          <br />
          <Text size="lg">
            {t('noReviews', { ns: 'review' })}
          </Text>
        </Constraint>
        <br />
        <SubmitReview
          notLoggedInLinkText={t('logInToReview', { ns: 'review' })}
          openModalLinkText={t('beFirstToReview', { ns: 'review' })}
          station={station}
        />
      </Fragment>
    );
  }

  return reviewsContent;
}

Reviews.propTypes = {
  error: PropTypes.string,
  hasMoreReviews: PropTypes.bool,
  isFetching: PropTypes.bool,
  loadMore: PropTypes.func,
  reviews: PropTypes.arrayOf(
    PropTypes.shape({
      reviewId: PropTypes.string.isRequired,
      reviewDate: PropTypes.string.isRequired,
      review: PropTypes.string.isRequired,
      profileImageUrl: PropTypes.string.isRequired,
      memberId: PropTypes.string.isRequired,
    }),
  ),
  station: StationPropType.isRequired,
};

Reviews.defaultProps = {
  error: undefined,
  hasMoreReviews: false,
  isFetching: false,
  loadMore: undefined,
  reviews: undefined,
};
